export default __webpack_public_path__ + "static/media/venue_location_icon_red.94aada47.svg";